import { useTranslation } from 'react-i18next';
import React from 'react';
import cx from 'clsx';
import { Button } from '@/components/Button';
import { FeedArticle } from '../../types';
import { useUnHidePost } from '../../hooks/list';

import styles from './index.module.scss';
import { isOfficalAddress } from '@/utils/address';
import { useMuteOperate } from '../FeedMoreAction/hooks';
import { useHistory } from 'react-router-dom';
import HelperTooltip from '@/components/HelperTooltip';

export const HideStreamCard = ({
  article,
  className,
}: {
  article: FeedArticle;
  className: string;
}) => {
  const { t } = useTranslation();

  const isOfficialFeed = isOfficalAddress(article.creator_id);
  const isMuted = isOfficialFeed
    ? (article?.creator as OfficialAccount)?.is_muted
    : (article?.creator as GeneralAccount)?.desc?.user?.is_muted;
  const history = useHistory();
  const { mutate: unHidePost } = useUnHidePost(article?.id);
  const { mutate: muteOperate } = useMuteOperate({
    action: isMuted ? 'unmute' : 'mute',
    userId: article?.creator_id,
  });

  const handleUndo = () => {
    unHidePost();
  };

  const handleMute = () => {
    muteOperate();
  };

  const handelViewAll = () => {
    history.push('/settings/muted-users');
  };

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.title}>{t('HideStreamCard.1i0q1gn')}</div>
      <div className={styles.undoBtn} onClick={handleUndo}>
        {t('HideStreamCard.1klxg')}
      </div>
      <HelperTooltip title={isMuted ? t('HideStreamCard.unmute') : undefined}>
        <Button
          className={cx(styles.muteBtn, isMuted && styles.muted)}
          type="form"
          onClick={handleMute}>
          {isMuted ? t('HideStreamCard.muted') : t('HideStreamCard.mute')}
        </Button>
      </HelperTooltip>
      <div className={styles.viewMuteList} onClick={handelViewAll}>
        {t('HideStreamCard.1no242i')}
      </div>
    </div>
  );
};
